// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RanaFeatureFlags
 */
export interface RanaFeatureFlags {
  /**
   *
   */
  enableModelSchematisationVectorPreview?: boolean;
  /**
   *
   */
  enableModelSchematisationForCollaborators?: boolean;
  /**
   *
   */
  enableWorkflows?: boolean;
  /**
   *
   */
  enableRasterSeries?: boolean;
}

/**
 * Check if a given object implements the RanaFeatureFlags interface.
 */
export function instanceOfRanaFeatureFlags(value: object): value is RanaFeatureFlags {
  return true;
}

export function RanaFeatureFlagsFromJSON(json: any): RanaFeatureFlags {
  return RanaFeatureFlagsFromJSONTyped(json, false);
}

export function RanaFeatureFlagsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RanaFeatureFlags {
  if (json == null) {
    return json;
  }
  return {
    enableModelSchematisationVectorPreview:
      json["enable_model_schematisation_vector_preview"] == null
        ? undefined
        : json["enable_model_schematisation_vector_preview"],
    enableModelSchematisationForCollaborators:
      json["enable_model_schematisation_for_collaborators"] == null
        ? undefined
        : json["enable_model_schematisation_for_collaborators"],
    enableWorkflows: json["enable_workflows"] == null ? undefined : json["enable_workflows"],
    enableRasterSeries:
      json["enable_raster_series"] == null ? undefined : json["enable_raster_series"],
  };
}

export function RanaFeatureFlagsToJSON(json: any): RanaFeatureFlags {
  return RanaFeatureFlagsToJSONTyped(json, false);
}

export function RanaFeatureFlagsToJSONTyped(
  value?: RanaFeatureFlags | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    enable_model_schematisation_vector_preview: value["enableModelSchematisationVectorPreview"],
    enable_model_schematisation_for_collaborators:
      value["enableModelSchematisationForCollaborators"],
    enable_workflows: value["enableWorkflows"],
    enable_raster_series: value["enableRasterSeries"],
  };
}
